module.exports = __webpack_public_path__ + "img/step-three-disabled.af49de24.svg";